// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__djIBC","emails":"CreateEditClinics_emails__1knJb","emailTagLabel":"CreateEditClinics_emailTagLabel__2PZf2"};